require("./bootstrap")

import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import { InertiaProgress } from '@inertiajs/progress'
import {InertiaMixin} from "./Mixins/Inertia.mixin";
import sharedFilters from '@s/Filters/filters';

InertiaProgress.init({
    showSpinner: true,
})

const app = createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    setup({ el, app, props, plugin }) {
        const createdApp = createApp({
            render: () => h(app, props)
        });
        createdApp.mixin(InertiaMixin);
        createdApp.use(plugin);
        createdApp.config.globalProperties.$filters = sharedFilters;
        createdApp.config.globalProperties.$hc = {

        };
        createdApp.mount(el);
    },
})

